module.exports = __webpack_public_path__ + "static/media/contactless-payment-symbol.4c07b232.png";